// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.info[data-v-7db16027] {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
